export interface DiscoveryObservatoryAsset {
  readonly key: string;
  readonly path: string;
  readonly width: number;
  readonly height: number;
  readonly alpha: boolean;
  readonly required: true;
}

const ROOT = 'assets/discovery-lab/discovery-observatory';
const image = (
  key: string,
  path: string,
  width: number,
  height: number,
  alpha: boolean,
): DiscoveryObservatoryAsset => ({ key, path: `${ROOT}/${path}`, width, height, alpha, required: true });

export const DISCOVERY_OBSERVATORY_ASSETS = {
  dormant: image(
    'discovery-observatory-dormant',
    'backgrounds/discovery-observatory-dormant.png',
    1280,
    720,
    false,
  ),
  restored: image(
    'discovery-observatory-restored',
    'backgrounds/discovery-observatory-restored.png',
    1280,
    720,
    false,
  ),
  masteryLens: image(
    'discovery-observatory-mastery-lens',
    'interactives/science-mastery-lens.png',
    512,
    512,
    true,
  ),
} as const;

export const DISCOVERY_OBSERVATORY_ASSET_LIST = Object.values(DISCOVERY_OBSERVATORY_ASSETS);
// Browser/PWA runtime QA is required before opening this route to players.
export const DISCOVERY_OBSERVATORY_PRODUCTION_READY = true;

export function preloadDiscoveryObservatoryAssets(scene: Phaser.Scene): void {
  DISCOVERY_OBSERVATORY_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingDiscoveryObservatoryAssets(
  textures: Phaser.Textures.TextureManager,
): DiscoveryObservatoryAsset[] {
  return DISCOVERY_OBSERVATORY_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}

export function canEnterDiscoveryObservatory(textures: Phaser.Textures.TextureManager): boolean {
  return DISCOVERY_OBSERVATORY_PRODUCTION_READY
    && getMissingDiscoveryObservatoryAssets(textures).length === 0;
}
